<template>
  <div class="ClockList">
    <div id="appBox">
      <XTable
          :api="getKnowledgeList"
          :state="knowledgeList"
          :columns="columns"
          :loading="knowledgeListLoading"
          :tableSize="tableSize"
          :firstColumn="firstColumn"
          :maxHeight="maxHeight"
          :layout="layout"
      ></XTable>
    </div>
    <ViewClockDetailsModal :rowDetails="rowDetails"></ViewClockDetailsModal>
  </div>
</template>

<script>
import XTable from "@/components/XTable/index.vue";
import {mapActions, mapMutations, mapState} from "vuex";
import {CLOCK_TYPE} from "@/utils/constants";
import DateUtil from "@/utils/formatDate";
import ViewClockDetailsModal from "@/pages/DailyClock/ViewClockDetailsModal.vue";

export default {
  name: "ClockList",
  components: {ViewClockDetailsModal, XTable},
  props: {
    maxHeight: {
      type: Number,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      tableSize: "small",
      layout: "sizes, prev, pager, next",
      firstColumn: true,
      rowDetails: {},
      back: false,
    };
  },
  computed: {
    ...mapState("pluginCenter", [
      "knowledgeList",
      "knowledgeListLoading",
      "ClockDetailsModalVisible",
    ]),
    ...mapState("user", ["permissionCode"]),
    columns: function () {
      const self = this;
      const columns = [
        {
          label: "类别",
          render(h, scope) {
            return (
                <div>
                  <span>{CLOCK_TYPE[scope.row.type]}</span>
                </div>
            );
          },
        },
        {
          prop: "name",
          label: "名称|课程名称",
        },
        {
          label: "内容属性",
          render(h, scope) {
            return (
                <div>
                  {scope.row && scope.row.materialUrl && <span>音频 | 文本</span>}
                  {scope.row && !scope.row.materialUrl && <span>文本</span>}
                </div>
            );
          },
        },
        {
          label: "内容概述",
          render(h, scope) {
            return (
                <div>
                  <div class="textBox">
                    {(scope.row && scope.row.displayDescription) || "-"}
                  </div>
                </div>
            );
          },
        },
        {
          prop: "createTime",
          label: "上传时间",
          render(h, scope) {
            return (
                <div>
                  <span>{self.formatDate(scope.row.createTime)}</span>
                </div>
            );
          },
        },
        // {
        //   prop: "displayCount",
        //   width: "100",
        //   label: "展示量",
        //   render(h, scope) {
        //     return (
        //         <div>
        //           <div class="textBox">
        //             {(scope.row && scope.row.displayCount) || 0}
        //           </div>
        //         </div>
        //     );
        //   },
        // },
      ];

      if (this.permissionCode.has('plugin:knowledge:manager')) {
        columns.push({
          label: "操作",
          fixed: "right",
          width: 280,
          render(h, scope) {
            return (
                <div>
                  <el-button
                      onClick={() => {
                        self.handleView(scope.row);
                      }}
                      size="mini"
                      type="primary"
                      plain
                  >
                    查看
                  </el-button>
                  <el-button
                      onClick={() => {
                        self.handleEdit(scope.row);
                      }}
                      size="mini"
                      type="primary"
                      plain
                  >
                    编辑
                  </el-button>
                  <el-button
                      onClick={() => {
                        self.handleDelete(scope.row);
                      }}
                      size="mini"
                      type="danger"
                      plain
                  >
                    删除
                  </el-button>
                </div>
            );
          },
        })
      }
      return columns;
    }
  },
  async mounted() {
    this.back = !!this.$route.params.back;
    if (this.back) {
      await this.getKnowledgeList({
        page: this.knowledgeList.page,
        size: this.knowledgeList.size,
      });
      this.back = false;
    }
    // this.handleResize();
    // window.addEventListener("resize", this.handleResize);
  },
  // beforeDestroy() {
  //   window.removeEventListener("resize", this.handleResize); // 移除resize事件监听
  //   console.log(111);
  // },
  methods: {
    ...mapActions("pluginCenter", ["getKnowledgeList", "deleteKnowledge"]),
    ...mapMutations("pluginCenter", ["setData"]),
    // handleResize() {
    //   this.$nextTick(() => {
    //     // const el1 = document.getElementById("appBox");
    //     const el2 = document.getElementById("xTable");
    //     console.log(el2);
    //     console.log(el2.offsetHeight);
    //     this.maxHeight = el2.offsetHeight - el2.offsetHeight * 0.3;
    //     console.log(this.maxHeight);
    //   });
    // },
    async handleView(row) {
      this.rowDetails = row;
      this.setData({key: "ClockDetailsModalVisible", value: true});
    },
    async handleEdit(row) {
      localStorage.setItem("clockDetail", JSON.stringify(row));
      await this.$router.push(
          {
            name: "AddClock",
            params: {
              type: "edit",
              id: row.id,
            },
          },
          () => {
          }
      );
    },
    async handleDelete(row) {
      this.$confirm("请确认是否要删除该条打卡内容!", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(async () => {
            try {
              await this.deleteKnowledge({
                id: row.id,
              });
              await this.getKnowledgeList({
                page: this.knowledgeList.page,
                size: this.knowledgeList.size,
              });
              this.$message.success("删除成功");
            } catch (e) {
              // console.log(e);
            }
          })
          .catch(() => {
          });
    },
    //   根据时间戳计算下达时间、开始时间、结束时间
    formatDate(timestamp) {
      return DateUtil.formatDateFromTimestamp(timestamp);
    },
  },
};
</script>

<style lang="scss" scoped>
.ClockList {
  ::v-deep .textBox {
    width: 100%;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; /* 最大显示两行 */
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
